import {
    KEYWORD_GENERATOR_TOOL_SET_COUNTRY,
    KEYWORD_GENERATOR_TOOL_SET_DURATION,
    KEYWORD_GENERATOR_TOOL_SET_SEED_KEYWORD,
    KEYWORD_GENERATOR_TOOL_SET_WEBSOURCE,
} from "../action_types/keyword_generator_tool_action_types";

export const setSeedKeyword = (seedKeyword: string) => {
    return {
        type: KEYWORD_GENERATOR_TOOL_SET_SEED_KEYWORD,
        seedKeyword,
    };
};

export const setCountry = (country: number) => {
    return {
        type: KEYWORD_GENERATOR_TOOL_SET_COUNTRY,
        country,
    };
};
export const setDuration = (duration: string) => {
    return {
        type: KEYWORD_GENERATOR_TOOL_SET_DURATION,
        duration,
    };
};
export const setWebSource = (webSource: string) => {
    return {
        type: KEYWORD_GENERATOR_TOOL_SET_WEBSOURCE,
        webSource,
    };
};
